import { InformationRequest } from '../../lib/types/models/information-request/information-request'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getInformationRequest(id: number) {
  return restApiClient
    .url(constructApiUrl(API.informationRequests.get.url, { id }))
    .get<InformationRequest>()
}
